import {useParams} from "react-router-dom";
import AboutItemPageHeader from "./components/page-header/PageHeader";
import {useAboutController} from "../../controllers/about-controller";
import {useEffect} from "react";
import AboutItemPageBody from "./components/page-body/PageBody";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";

const AboutItemPage = () => {
  const {aboutId} = useParams()
  const aboutController = useAboutController()
  const {getAboutItemById} = aboutController

  useEffect(() => {
    if (aboutId) {
      getAboutItemById(aboutId)
    }
  }, [aboutId])

  return <div className="about-item-page">
    <div className="about-item-page__navigation">
      <AboutItemPageHeader/>
    </div>
    <main className="about-item-page__content">
      <AboutItemPageBody aboutController={aboutController}/>
    </main>
    <ScrollToTopButton elementSelector={".about-item-page__content"}/>
  </div>
}

export default AboutItemPage
